"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _TagSet_1 = require("./_TagSet");
exports.GetObjectTaggingOutput = {
    type: "structure",
    required: ["TagSet"],
    members: {
        VersionId: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-version-id"
        },
        TagSet: {
            shape: _TagSet_1._TagSet
        }
    }
};
//# sourceMappingURL=GetObjectTaggingOutput.js.map